/**
 * @ngdoc controller
 * @name ce-app:MobileBuilderCtrl
 *
 * @description
 *
 *
 * @requires $scope
 * */
import angular from 'angular';
import mainSearchViewUrl from './header-main-search.controller.html';
import headerMobileHomeViewUrl from './header-mobile-home.controller.html';
import headerMobileTechViewUrl from './header-mobile-technology.controller.html';
import headerMobileDistViewUrl from './header-mobile-distributor.controller.html';
import sidebarUrl from './../../components/sidebar/sidebar.html';

/* @ngInject */
export default function HeaderController($scope, $route, $location, $document, $translate, $log, CacheService, ContainerInfoApiService, __env) {
    $scope.actionName = 'label__action_filter';
    $scope.isActionOpenBuilder = true;
    $scope.isActionClose = false;
    $scope.isParametersOpened = false;
    $scope.isProductsOpened = true;
    $scope.hideTooltip = true;
    $scope.containerModified = '';
    $scope.pnfModified = '';
    $scope.showContainerInfo = false;

    $scope.mainSearchView = mainSearchViewUrl;
    $scope.headerMobileHomeView = headerMobileHomeViewUrl;
    $scope.headerMobileTechView = headerMobileTechViewUrl;
    $scope.headerMobileDistView = headerMobileDistViewUrl;
    $scope.sidebarUrl = sidebarUrl;

    var mastHead = document.getElementById('masthead');
    $scope.$on('$locationChangeSuccess', function () {
        $scope.route = $location.path();
        if ($scope.route === '/browsing') {
            //set these implicitly because of the potential for multiple hits per navigating in the browsing route.
            $scope.actionName = 'label__action_filter';
            mastHead.style.height = '';
            $scope.isParametersOpened = true;
            $scope.isProductsOpened = false;
        } else if ($scope.route === '/') {
            $scope.actionName = 'label__action_filter';
            mastHead.style.height = '';
            $scope.isParametersOpened = false;
            $scope.isProductsOpened = true;
        }
    });

    $scope.chooseTooltipContent = function () {
        var number = Math.floor(Math.random() * 3) + 1; // currently only three supported tooltips

        $scope.emphasis = 'label__tooltip__' + number + '__emphasis';
        $scope.description = 'label__tooltip__' + number + '__description';
    };

    $scope.init = function () {
        $scope.chooseTooltipContent();
        // show tooltip after content is rendered.
        $scope.hideTooltip = false;

        ContainerInfoApiService.getContainerInfo(function (info) {
            if (__env.dev === undefined || __env.dev) {
                $scope.showContainerInfo = __env.dev;
                $scope.containerModified = info.resourceInfoList.filter(resource => resource.resourceType === 'CONTAINER')[0].dateModified;
                $scope.pnfModified = info.resourceInfoList.filter(resource => resource.resourceType === 'PNF')[0].dateModified;
                if (__env.dev === undefined) {
                    $log.warn('If you\'re seeing this, please set the dev prop in your env_localhost file.');
                }
            }
        }, function (error) {
            $log.error(error);
        });
    };

    $scope.init();

    $scope.handleAction = function () {

        if ($scope.isActionOpenBuilder) {
            angular.element(document.body).addClass('pointers');
            $scope.isActionOpenBuilder = !$scope.isActionOpenBuilder;
            $scope.isActionClose = !$scope.isActionClose;
            $scope.actionName = 'label__action_close';
            mastHead.style.height = '100%';
        } else {
            angular.element(document.body).removeClass('pointers');
            $scope.isActionOpenBuilder = !$scope.isActionOpenBuilder;
            $scope.isActionClose = !$scope.isActionClose;
            $scope.actionName = 'label__action_filter';
            mastHead.style.height = '';
        }
    };

    $scope.isActive = function (viewLoc) {
        if (typeof viewLoc === 'string') {
            return viewLoc === $location.path();
        } else if (Array.isArray(viewLoc)) {
            for (let i = 0; i > viewLoc.length; ++i) {
                if (viewLoc[i] === $location.path()) {
                    return true;
                }
            }
        }
    };
}
